import { useEffect } from 'react';

import { ProductViewSource } from '@models';
import { PRODUCT_PAGE_REFERRER } from '@constants';
import { getProductPageReferrerFromStorage } from '@utils/common';

import { useProductIncrViewsLazyQuery } from './gql/graphql.v3.generated';

const getSource = (productId: number) => {
  const storageReferrer = getProductPageReferrerFromStorage(productId);

  if (storageReferrer === PRODUCT_PAGE_REFERRER.CATALOG || storageReferrer === PRODUCT_PAGE_REFERRER.CATALOG_SEARCH) {
    return ProductViewSource.Catalog;
  } else if (storageReferrer === PRODUCT_PAGE_REFERRER.DYNAMIC_COLLECTION) {
    return ProductViewSource.Collection;
  }

  return undefined;
};

interface Payload {
  productId: number,
  isFromAdvert?: boolean,
  isIncrViews?: boolean,
}

export const useProductIncrViews = ({
  productId,
  isFromAdvert,
  isIncrViews,
}: Payload) => {

  const [incrViews] = useProductIncrViewsLazyQuery();

  useEffect(() => {
    if (isIncrViews) {
      const source = getSource(productId);
      incrViews({
        variables: {
          productId,
          source,
          fromAdv: isFromAdvert,
          incrViews: isIncrViews,
        },
      });
    }
  }, [isFromAdvert, isIncrViews, incrViews, productId]);
};
